// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer .footer__menu .menu-children .mr-70{margin-right:0;max-width:90px}@media (max-width:767px){footer .footer__menu .menu-children .mr-70{max-width:unset}}footer .footer__menu .menu-children a.title{color:#000;font-size:13px;font-family:Hm-Pangram;transition:.2s ease;line-height:21px!important}footer .footer__menu .menu-children a.title:hover{color:#e50b09!important}footer .footer__menu .menu-children a:last-child{display:none}", ""]);
// Exports
module.exports = exports;
